import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import ImageUpload from "components/shared/ImageUpload";
import { Input, Textarea } from "components/shared/FormComponents";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import Form from "react-bootstrap/Form";

const Section = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);

  const [lightModeCharacter, setLightModeCharacter] = useState({
    preview: null,
    path: "",
  });
  const [darkModeCharacter, setdarkModeCharacter] = useState({
    preview: null,
    path: "",
  });
  const [sectionActivition, setSectionActivition] = useState(true);
  const sectionActivitionHandler = () =>
    setSectionActivition(!sectionActivition);

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "intro",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset({
      heading: section?.heading,
      characterRole: section?.characterRole,
      characterName: section?.characterName,
      characterDescription: section?.characterDescription,
    });
    setSectionActivition(section?.sectionActivition);
    setLightModeCharacter({
      preview: null,
      path: section?.lightModeCharacter,
    });
    setdarkModeCharacter({
      preview: null,
      path: section?.darkModeCharacter,
    });
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    if (!lightModeCharacter?.path || !darkModeCharacter?.path) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }
    data.lightModeCharacter = lightModeCharacter?.path;
    data.darkModeCharacter = darkModeCharacter?.path;
    data.sectionActivition = sectionActivition;

    dispatch(
      editSection({ slug: "intro", page: "home", data: { section: data } })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"intro"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={8} md={12}>
                <Row>
                  {/* image  */}
                  <Col lg={6} xs={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id={"lightModeCharacter"} />
                      </h5>
                      <ImageUpload
                        selectedImage={lightModeCharacter}
                        setSelectedImage={setLightModeCharacter}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id={"darkModeCharacter"} />
                      </h5>
                      <ImageUpload
                        selectedImage={darkModeCharacter}
                        setSelectedImage={setdarkModeCharacter}
                      />
                    </div>
                  </Col>
                </Row>

                {/* heading  */}
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.en"
                      register={register}
                      errors={errors}
                      dir="ltr"
                    />
                  </Col>

                  {/* </Row>
                <Row> */}
                  {/* <Col lg={6} xs={12}>
                    <Input
                      langId="boldTitle"
                      name="boldHeading.ar"
                      register={register}
                      errors={errors}
                      rules={{ required: false }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="boldTitle"
                      name="boldHeading.en"
                      register={register}
                      errors={errors}
                      rules={{ required: false }}
                    />
                  </Col> */}
                  {/* </Row>
                <Row> */}
                  {/* <Col lg={6} xs={12}>
                    <Textarea
                      langId="description"
                      name="description.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="description"
                      name="description.en"
                      register={register}
                      errors={errors}
                    />
                  </Col> */}
                </Row>
                <div className="card-head">
                  <h4>
                    <FormattedMessage id={"character-info"} />
                  </h4>
                </div>
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="characterName"
                      name="characterName.ar"
                      register={register}
                      errors={errors}
                      rules={{ required: true }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="characterName"
                      name="characterName.en"
                      register={register}
                      errors={errors}
                      rules={{ required: true }}
                      dir="ltr"
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="characterRole"
                      name="characterRole.ar"
                      register={register}
                      errors={errors}
                      rules={{ required: true }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="characterRole"
                      name="characterRole.en"
                      register={register}
                      errors={errors}
                      rules={{ required: true }}
                      dir="ltr"
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="characterDescription"
                      name="characterDescription.ar"
                      register={register}
                      errors={errors}
                      rules={{ required: true }}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      langId="characterDescription"
                      name="characterDescription.en"
                      register={register}
                      errors={errors}
                      rules={{ required: true }}
                      dir="ltr"
                    />
                  </Col>
                </Row>
                <Col md={4} xs={12}>
                  <div className="only-radio toggle-switch mb-5">
                    <label className="switch-label" htmlFor="sectionActivition">
                      <FormattedMessage id="sectionActivition" />
                    </label>
                    <label className="switch" htmlFor="sectionActivition">
                      <input
                        id="sectionActivition"
                        type="checkbox"
                        checked={sectionActivition}
                        onChange={sectionActivitionHandler}
                      />
                      <span className="slider"></span>
                    </label>
                  </div>
                </Col>

                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section;
